// External
import { useMemo } from 'react';

// Project
import { getFilteredPaymentsReceivedData } from '../utils/payments';

// Feature
import { usePayments } from '../api';
import { FilteredPayments } from '../types';

export const useNcpFilteredPayments = (
  caseId: string,
  pin: string,
  isAppUserAgency: boolean
): FilteredPayments => {
  const { data: payments, isLoading, error } = usePayments(caseId, pin, isAppUserAgency);

  const filteredData = useMemo(() => {
    if (!payments) return { pendingPayments: [], receivedPayments: [] };
    return getFilteredPaymentsReceivedData(payments);
  }, [payments]);

  const result: FilteredPayments = {
    pendingPayments: filteredData.pendingPayments,
    receivedPayments: filteredData.receivedPayments,
    isLoading,
    error,
  };

  return result;
};
